/**
 * @file 生成请求序列号，用于统计丢失率
 * @author wuyufeng<wuyufeng@baijiahulian.com>
 * @module util/requestIdx
 */

import {Config} from './config';
import {detectStorage} from './detectStorageAvailability';

/**
 * 将日期转成 YYYY-MM-DD 的格式
 * @param {Date} recordDay
 */
export const getDate = function (recordDay) {
    return `${recordDay.getFullYear()}-${recordDay.getMonth() + 1}-${recordDay.getDate()}`;
};

const isObject = target => Object.prototype.toString.call(target).slice(8, -1) === 'Object';

// 存储 req_idx 键。
const KEY = 'REQ_IDX';

// 能否使用 localStorage 标识符。
const CAN_I_USE_STORE = detectStorage();

export const defaultReqIdxStore = () => ({recordDay: '', data: {}});

let ReqIdxStore = null;

/**
 * 从 localStorage 中获取 ReqIdxStore 。
 */
const getReqIdxFromStore = () => {
    try {
        const {recordDay = '', data = {}} = JSON.parse(localStorage.getItem(`${Config.NAME}-${KEY}`));
        return {
            recordDay,
            data: isObject(data) ? data : {}
        };
    }
    catch (e) {
        return ReqIdxStore || defaultReqIdxStore();
    }
};

/**
 * 初始化 ReqIdxStore 。
 * @param {any} store
 */
export const initReqIdxStore = function (store) {
    ReqIdxStore = typeof store === 'undefined'
        ? (CAN_I_USE_STORE ? getReqIdxFromStore() : defaultReqIdxStore())
        : store;
};

/**
 * 将 ReqIdxStore 保存至 localStorage 。
 */
const saveReqIdxToStore = () => {
    const _ = () => {
        localStorage.setItem(`${Config.NAME}-${KEY}`, JSON.stringify(ReqIdxStore));
    };
    CAN_I_USE_STORE && _();
};

/**
 * 计算 req_idx ，用于统计丢失率，以四个维度区分，recordDay && Config.Name && type 。
 */
const getReqIdx = (url, gid) => {
    const type = Object.keys(Config).filter(key => Config[key] === url)[0];
    // 获取当前日期，对比 store 中日期，不同则重置。
    const today = getDate(new Date());
    if (!ReqIdxStore) {
        initReqIdxStore();
    }
    CAN_I_USE_STORE && (ReqIdxStore = getReqIdxFromStore());
    let {recordDay, data} = ReqIdxStore;
    today !== recordDay && (data = {}) && (recordDay = today);
    const key = `${Config.NAME}-${type}-${gid || 'nogid'}`;
    (key in data) ? data[key]++ : data[key] = 1;
    ReqIdxStore.recordDay = recordDay;
    ReqIdxStore.data = data;
    saveReqIdxToStore();
    return data[key];
};

export default getReqIdx;
